import { useState } from 'react';

import { Tier, SIDEBAR_COLLAPSED_WIDTH } from '@backrs_ui/common-ui';

import { SchoolLevel } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

import { PageMarker } from './atoms/PageMarker';
import { MiddleButton } from './molecules/MiddleButton';
import { TabbedContainer } from './molecules/TabbedContainer';

export const MarkersOfSuccessPage = () => {
  const [tabOneTier, setTabOneTier] = useState<Tier>('Trades');
  const [tabOneSchoolLevel, setTabOneSchoolLevel] = useState<SchoolLevel>('high_school');

  const [tabTwoTier, setTabTwoTier] = useState<Tier | undefined>();
  const [tabTwoSchoolLevel, setTabTwoSchoolLevel] = useState<SchoolLevel | undefined>();

  const [isMiddleButtonPopoverOpen, setIsMiddleButtonPopoverOpen] = useState(false);

  return (
    <Box sx={pageContainerStyle}>
      <PageMarker />
      <Box
        sx={{
          ...containerStyle,
          justifyContent: tabTwoTier || tabTwoSchoolLevel ? 'space-between' : 'flex-start',
        }}
      >
        <TabbedContainer
          tier={tabOneTier}
          schoolLevel={tabOneSchoolLevel}
          handleTierChange={setTabOneTier}
          handleSchoolLevelChange={setTabOneSchoolLevel}
        />
        <MiddleButton
          setIsMiddleButtonPopoverOpen={setIsMiddleButtonPopoverOpen}
          isMiddleButtonPopoverOpen={isMiddleButtonPopoverOpen}
          setTabTwoTier={setTabTwoTier}
          setTabTwoSchoolLevel={setTabTwoSchoolLevel}
          tabTwoTier={tabTwoTier}
          tabTwoSchoolLevel={tabTwoSchoolLevel}
        />
        {(tabTwoTier || tabTwoSchoolLevel) && (
          <TabbedContainer
            tier={tabTwoTier || 'Top-Tier Professional'}
            schoolLevel={tabTwoSchoolLevel || 'high_school'}
            handleTierChange={setTabTwoTier}
            handleSchoolLevelChange={setTabTwoSchoolLevel}
          />
        )}
      </Box>
    </Box>
  );
};

const pageContainerStyle: SxProps<Theme> = {
  pl: 3,
  pb: 4,
  width: '100%',
  ml: `${SIDEBAR_COLLAPSED_WIDTH}px`,
} as const;

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  alignItems: 'center',
  flexGrow: 1,
  width: '100%',
  boxSizing: 'border-box',
  mt: 12,
  gap: {
    xs: 4,
    md: 0,
  },
} as const;
